'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'

export const TimeRecordingModeSwitcher = ({ mode, onClick }) => {
  return (
    <MUIStack data-testid="TimeRecordingModeSwitcher" direction="row" alignItems="center" justifyContent="flex-start">
      {renderButton({ onClick, mode, value: 'timers', label: 'Timers', index: 0 })}
      {renderButton({ onClick, mode, value: 'postings', label: ' Time ledger postings', index: 1 })}
    </MUIStack>
  )
}

const renderButton = ({ onClick, mode, value, label, index }) => {
  const isActive = mode === value

  return (
    <MUIButton
      variant="contained"
      sx={{
        height: '22px',
        borderTopLeftRadius: index === 1 ? 0 : '11px',
        borderBottomLeftRadius: index === 1 ? 0 : '11px',
        borderTopRightRadius: index === 0 ? 0 : '11px',
        borderBottomRightRadius: index === 0 ? 0 : '11px',
        color: isActive ? 'white' : 'text.secondary',
        backgroundColor: isActive ? 'secondary.main' : 'greyShades.grey1',
        textTransform: 'none',
        fontSize: '0.75rem',
        fontWeight: 600,
        '&:hover': {
          backgroundColor: isActive ? 'secondary.main' : 'greyShades.grey2',
          color: isActive ? 'white' : 'text.secondary'
        }
      }}
      onClick={() => onClick(value)}
    >
      {label}
    </MUIButton>
  )
}

TimeRecordingModeSwitcher.propTypes = {
  mode: PropTypes.string,
  onClick: PropTypes.func
}
